import { EmployeeLocation } from './employee-location.model';

export interface Merchant {
  $id: string;
  MerchantId: number;
  Name: string;
  Locations: EmployeeLocation[];
}
